import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { Box, Tab, Tabs, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import styled from "styled-components";
import { AppMaterialIcons } from "../../../../AppComponents/AppMaterialIcons";
import { ProtectedAppButton } from "../../../../AppComponents/ProtectedComponents";
import { theme } from "../../../../Customization/Theme";
import { useAppSelector } from "../../../../Store";
import { useCurrentUser } from "../../../../Store/Slices/CurrentUser/CurrentUserSlice";
import { AppToolTip } from "../../../UiComponents/AppToolTip/AppToolTip";
import { LeftCol, RightCol, TopBar } from "../BroadcastHistory/HistoryStyles";
import useDocumentTitle from "../../../../Hooks/useDocumentTitle";
import { useAuthStore } from "../../../../Store/Slices/AuthSlice";
import useFavicon from "../../../../Hooks/useFavicon";

// const getCurrentPathName = (pathname: string) => {
//   let result = "broadcast";
//   if (pathname.includes("history")) {
//     result = "Broadcast";
//   } else if (pathname.includes("templates")) {
//     result = "Templates";
//   } else if (pathname.includes("scheduled")) {
//     result = "Scheduled";
//   }

//   return result;
// };

const WhatsappTopbar = () => {
  const { userCreditsInfo } = useAppSelector(useCurrentUser);
  const { data: authData, userConfig } = useAppSelector(useAuthStore);
  const location = useLocation();
  // const pathName = getCurrentPathName(location?.pathname);
  const [value, setValue] = useState("/broadcast/whatsapp/history");
  useDocumentTitle("WhatsApp");
  useFavicon();

  const handleChange = (event: React.SyntheticEvent, newValue: string) => {
    setValue(newValue);
  };

  useEffect(() => {
    setValue(location.pathname);
  }, [location.pathname]);

  return (
    <>
      <TopBar>
        <LeftCol>
          <label>To know your Messaging Limit please</label>
          <Box className="limit">
            <a
              href="https://developers.facebook.com/docs/whatsapp/messaging-limits/"
              target="_blank"
              rel="noreferrer"
            >
              Click here
            </a>
          </Box>
        </LeftCol>
        <RightCol>
          <Box className="contact">
            <label>
              <span className="contact-label">
                Connected WA No.:{" "}
                <span style={{ fontWeight: 500 }}>
                  {userConfig?.payload?.whatasapp_config?.whatsapp_no ??
                    "Number not connected yet"}
                </span>
              </span>
              {/* <strong> {credits?.whatsapp_no}</strong> */}
            </label>
          </Box>
          <Box>
            {/* <Box className="monthly-conversations__wrapper">
              <Box className="conversations">
                <Box className="monthly-conversations">
                  <AppToolTip
                    tooltipProps={{
                      title: `Each WhatsApp Business Account gets 1000 free service conversations (user-initiated conversations) each month across all of its business phone numbers. This number is refreshed at the beginning of each month, based on WhatsApp Business Account time zone. Marketing, utility and authentication conversations are not part of the free tier`,
                      placement: "right",
                    }}
                    iconButtonProps={{ disableRipple: "true" }}
                    id="contacted-wa-no-tooltip"
                    IconComponent={
                      <InfoOutlinedIcon style={{ marginRight: "4px" }} />
                    }
                  />
                  <div className="conversations-label">
                    Free Monthly conversations:
                    <strong> {userCreditsInfo?.free_conversation}</strong>
                  </div>
                </Box>
              </Box>
            </Box> */}
          </Box>
        </RightCol>
      </TopBar>
      <StyledTabsWrapper className="topTitle-left">
        {location?.pathname?.toLowerCase()?.includes("/whatsapp/templates") ||
        location?.pathname
          ?.toLowerCase()
          ?.includes("/whatsapp/default_template") ? (
          <Tabs
            value={value}
            // onChange={handleChange}
            aria-label="nav tabs example"
            role="navigation"
          >
            <StyledLinkTab
              label={
                <Typography fontSize="14px" fontWeight="500" component="h6">
                  Template Gallery
                </Typography>
              }
              component={Link as any}
              to={`/broadcast/whatsapp/default_template`}
              value={`/broadcast/whatsapp/default_template`}
              disableFocusRipple
              disableRipple
            />
            <StyledLinkTab
              label={
                <Typography fontSize="14px" fontWeight="500" component="h6">
                  Templates List
                </Typography>
              }
              component={Link as any}
              to={`/broadcast/whatsapp/templates`}
              value={`/broadcast/whatsapp/templates`}
              disableFocusRipple
              disableRipple
            />
          </Tabs>
        ) : null}
        {location?.pathname?.toLowerCase()?.includes("/whatsapp/history") ||
        location?.pathname?.toLowerCase()?.includes("/whatsapp/scheduled") ||
        location?.pathname?.toLowerCase()?.includes("/whatsapp/logs") ? (
          <Tabs
            value={value}
            // onChange={handleChange}
            aria-label="nav tabs example"
            role="navigation"
          >
            <StyledLinkTab
              id="broadcast-broadcast_list"
              label={
                <Typography fontSize="14px" fontWeight="500" component="h6">
                  Broadcast list
                </Typography>
              }
              component={Link as any}
              to={`/broadcast/whatsapp/history`}
              value={`/broadcast/whatsapp/history`}
              disableFocusRipple
              disableRipple
            />
            <StyledLinkTab
              id="broadcast-scheduled_broadcast"
              label={
                <Typography fontSize="14px" fontWeight="500" component="h6">
                  Scheduled broadcast
                </Typography>
              }
              component={Link as any}
              to={`/broadcast/whatsapp/scheduled`}
              value={`/broadcast/whatsapp/scheduled`}
              disableFocusRipple
              disableRipple
            />
            <StyledLinkTab
              id="broadcast-broadcast_logs"
              label={
                <Typography fontSize="14px" fontWeight="500" component="h6">
                  Logs
                </Typography>
              }
              component={Link as any}
              to={`/broadcast/whatsapp/logs`}
              value={`/broadcast/whatsapp/logs`}
              disableFocusRipple
              disableRipple
            />
          </Tabs>
        ) : null}

        <Box className="topTitle-right">
          {location?.pathname?.toLowerCase()?.includes("/whatsapp/templates") ||
          location?.pathname
            ?.toLowerCase()
            ?.includes("/whatsapp/default_template") ? (
            <ProtectedAppButton
              moduleId="whatsapp_template"
              specificPermissionKey="create"
              variant="primarydark"
              style={{ minWidth: "170px" }}
              component={Link}
              to={`/broadcast/whatsapp/create-template`}
            >
              <AppMaterialIcons iconName="Add" />
              Create Template
            </ProtectedAppButton>
          ) : null}
          {location?.pathname?.toLowerCase()?.includes("/whatsapp/history") ||
          location?.pathname?.toLowerCase()?.includes("/whatsapp/scheduled") ? (
            <ProtectedAppButton
              moduleId="whatsapp_broadcast_crud"
              specificPermissionKey="create"
              variant="primarydark"
              style={{ minWidth: "170px" }}
              component={Link}
              to={`/broadcast/whatsapp/create-broadcast/1`}
              id="broadcast-topbar-create_broadcast"
            >
              Create Broadcast
              <AppMaterialIcons iconName="Add" />
            </ProtectedAppButton>
          ) : null}
        </Box>
      </StyledTabsWrapper>
    </>
  );
};

export default WhatsappTopbar;

const StyledTabsWrapper = styled(Box)`
  && {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 8px 16px 16px 16px;
    background-color: ${theme.palette.default.lightGrey};
    .topTitle-left {
      display: flex;
      align-items: center;

      .div_tooltip {
        font-size: 10px;
      }
    }
    .topTitle-right {
      display: flex;
      align-items: center;
      gap: 12px;
    }
    /* background-color: white; */

    .selected-tab {
      background-color: ${theme.palette.default.white} !important;
      color: ${theme.palette.default.text};

      .MuiIconButton-root {
        display: inline !important; // Show when tab is selected
      }
    }
  }

  .Mui-selected {
    background-color: ${theme.palette.default.white} !important;
    border-radius: 6px 6px 0 0;
  }

  .scrollBtns {
    font-size: 14px;
    padding: 4px;
    svg {
      font-size: 14px;
    }
  }

  .MuiTabs-root {
    background-color: ${theme.palette.default.lightGrey} !important;
  }
  .MuiTabs-indicator {
    display: none;
  }
  .MuiTabs-scrollButtons {
    &.Mui-disabled {
      display: none;
      opacity: 0;
    }
  }
`;

const StyledLinkTab = styled(Tab)`
  && {
    text-transform: none;
    color: ${theme.palette.default.darkGrey};
    padding: 4px 12px;
    min-height: 40px;
  }
` as typeof Tab;
